import { generateApiUrl } from '@common/api/configure';
import { ApiRoute } from '@common/api/route';

export const getCheckoutUrl = (coreServerUrl: string) => new URL(generateApiUrl(ApiRoute.ClientBillingSubscriptionStart), coreServerUrl);
